/*
 * Icon Atom Component
 *
 * Help (with example) from: https://github.com/parcel-bundler/parcel/issues/2246
 * SVG `symbol` a Good Choice for Icons by Chris Coyier: https://css-tricks.com/svg-symbol-good-choice-icons
 * Creating an SVG Icon System with React by Sarah Drasner: https://css-tricks.com/creating-svg-icon-system-react
 * xlink:href Deprecated: https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/xlink:href
 * Accessible SVGs by Heather Migliorisi https://css-tricks.com/accessible-svgs/
 */

import React from "react"
import PropTypes from "prop-types"
import IconsSprite from "../../../ally/4_foundations/4_iconography/iconSprite.svg"

const Icon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      className={`icon icon${props.modifier}`}
    >
      <title>{props.title}</title>
      <use href={`${IconsSprite}#${props.name}`} />
    </svg>
  )
}

Icon.defaultProps = {
  name: "chevron",
  title: "",
  modifier: "",
}

Icon.propTypes = {
  name: PropTypes.oneOf([
    "chevron",
    "close",
    "copyright",
    "dark-mode",
    "expand",
    "filter",
    "mail",
    "menu",
    "open-in-new",
    "social-instagram",
    "social-linkedin",
    "social-researchgate",
    "social-website",
    "social-x",
    "social-youtube",
    "sort",
  ]),
  title: PropTypes.string,
  modifier: PropTypes.oneOf(["", "--small", "--x-small", "--social-icons"]),
}

export default Icon
